// src/config/Drop.js
//
// Source unique de vérité pour les dates du drop et l'état du site.
// Ne pas redéfinir DROP_AT ni formatCountdown ailleurs : tout doit venir d'ici.

// ✅ Ouverture du drop : dimanche 20 septembre 2026 à 18h00, heure de Paris.
// La date est écrite en ISO avec l'offset explicite (+02:00 = heure d'été,
// en vigueur à Paris en septembre). Résultat : le drop tombe au même instant
// pour tout le monde, quel que soit le fuseau horaire du visiteur.
// Pour changer la date, ne modifier que cette ligne.
export const DROP_AT = new Date("2026-09-20T18:00:00+02:00");

// ✅ Fermeture automatique du drop : désactivée.
// Une fois ouvert, le site le reste jusqu'à fermeture manuelle — depuis /admin,
// ou via REACT_APP_SITE_OVERRIDE=closed_post dans les réglages Vercel.
// Pour réactiver une fermeture automatique, mettre une date au même format :
//   export const CLOSE_AT = new Date("2026-11-22T18:00:00+01:00");
// (attention à l'offset : +01:00 de fin octobre à fin mars, +02:00 le reste)
export const CLOSE_AT = null;

// Manuel (persistant). Valeurs possibles:
// "auto" (default) | "open" | "closed_pre" | "closed_post"
export const MANUAL_KEY = "GS_SITE_STATE";

export function getManualState() {
  return localStorage.getItem(MANUAL_KEY) || "auto";
}

export function setManualState(v) {
  localStorage.setItem(MANUAL_KEY, v);
}

export function getAutoState(now = new Date()) {
  // Avant le drop => compte à rebours
  if (now.getTime() < DROP_AT.getTime()) return "closed_pre";
  // Après la fermeture, si une date de fermeture est définie => site fermé
  if (CLOSE_AT && now.getTime() >= CLOSE_AT.getTime()) return "closed_post";
  // Sinon => ouvert
  return "open";
}

export function getSiteState(now = new Date()) {
  // ✅ Override GLOBAL (Vercel env) : open / closed_pre / closed_post
  // (si non défini => on continue normalement)
  const envOverride = process.env.REACT_APP_SITE_OVERRIDE;
  if (
    envOverride === "open" ||
    envOverride === "closed_pre" ||
    envOverride === "closed_post"
  ) {
    return envOverride;
  }

  // ✅ Override LOCAL (ton navigateur seulement)
  const manual = getManualState();
  if (manual !== "auto") return manual;

  // ✅ Auto (date)
  return getAutoState(now);
}

export function formatCountdown(ms) {
  const total = Math.max(0, ms);
  const sec = Math.floor(total / 1000);
  const s = sec % 60;
  const min = Math.floor(sec / 60) % 60;
  const h = Math.floor(sec / 3600) % 24;
  const d = Math.floor(sec / 86400);

  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d)}:${pad(h)}:${pad(min)}:${pad(s)}`; // JJ:HH:MM:SS
}
